class Cf7 {
    constructor() {
        this.sourceUrlFieldName = 'source-page-url';
    }

    init() {
        this.fillSourcePageUrlFields();

        document.addEventListener('wpcf7beforesubmit', () => {
            this.fillSourcePageUrlFields();
        });

        document.addEventListener(
            'submit',
            () => {
                this.fillSourcePageUrlFields();
            },
            true
        );
    }

    getCurrentPageUrl() {
        return window.location.href;
    }

    fillSourcePageUrlFields() {
        const currentPageUrl = this.getCurrentPageUrl();

        const fields = document.querySelectorAll(
            `input[name="${this.sourceUrlFieldName}"]`
        );

        fields.forEach((field) => {
            field.value = currentPageUrl;
        });
    }
}

export default Cf7;